import { PalletSection } from "../interfaces/intakes.reports";

export const updateAllPalletsSection = (
  sectionData: PalletSection,
  label: string,
  name: string,
  value: any,
): PalletSection => {

  let found = false;

  const data = sectionData.data.map(item => {
    if (item.name === name) {
      found = true;
      return { ...item, value };
    }
    return item;
  });

  if (!found) {
    data.push({
      name,
      label,
      value
    });
  }

  return {
    ...sectionData,
    data
  };
};